import { render, staticRenderFns } from "./Tekst.vue?vue&type=template&id=e2653a32&scoped=true&"
import script from "./Tekst.vue?vue&type=script&lang=js&"
export * from "./Tekst.vue?vue&type=script&lang=js&"
import style0 from "./Tekst.vue?vue&type=style&index=0&id=e2653a32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2653a32",
  null
  
)

export default component.exports